import * as THREE from 'three';
// import { TrackballControls } from 'three/examples/jsm/controls/TrackballControls.js';
import { CSS2DRenderer } from 'three/examples/jsm/renderers/CSS2DRenderer.js';
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js';
import { Simplex, Permutohedron, braidArrangement } from './geometry.js';
import { Colors } from './colors.js';
import * as MATH from './mymath.js';
import './css/tailwind/before.css';
import './css/style.css';
import './css/tailwind/after.css';

window.mat = MATH;


function animate() {
    requestAnimationFrame(animate);
    controls.update();
    render();
}


function render() {
	renderer.render( scene, camera );
    labelRenderer.render( scene, camera );
}


window.addEventListener('resize', () => {
    // camera.aspect = window.innerWidth / window.innerHeight;
    // renderer.setSize(window.innerWidth, window.innerHeight);
    // // renderer.setPixelRatio( window.devicePixelRatio );
    // camera.updateProjectionMatrix();
    const height = container.clientHeight; // Math.min(canvas.clientHeight, window.innerHeight);
    const width = container.clientWidth; //Math.min(canvas.clientWidth, window.innerWidth);
    renderer.setSize(width, height);
    labelRenderer.setSize(width, height);
    camera.aspect = width / height;
    camera.updateProjectionMatrix();
});


function drawSimplex ( dim ) {
    if ( simplex !== undefined ) {
        simplex.remove();
    }
    simplex = new Simplex([0, 0, 0], dim, 1., colors.colors);
    // scene.add(s.polytope);
    scene.add(simplex.vertices);
    scene.add(simplex.constructBarycentric());
    if ( point !== undefined ) {
        point.parent.remove(point);
        point = undefined;
    }
    controls.target = new THREE.Vector3(0, 0, 0);
    camera.position.set(...campos);
}


function createSliders (dim) {
    const sidebar = document.getElementById('left-controls');
    while (sidebar.firstChild) {
        sidebar.firstChild.remove()
    }
    while (results.firstChild) {
        results.firstChild.remove()
    }
    for ( let i = 0; i < dim; i++ ) {
        let sliderContainer = document.createElement('div');
        sliderContainer.classList.add('slider-container');
        let label = document.createElement('span');
        const color = '#' + new THREE.Color(simplex.colors[i]).getHexString();
        label.style.color = color;
        label.innerText = simplex.labels[i].innerText;
        label.classList.add('slider-label');
        let slider = document.createElement('input');
        slider.classList.add('slider');
        slider.id = "class" + i;
        slider.type = 'range';
        slider.min = -5;
        slider.max = 5;
        slider.value = 0.0;
        slider.step = 0.01;
        slider.style.background = color;
        slider.oninput = function ( e ) {
            computePoint();
        }
        sliderContainer.appendChild(label);
        sliderContainer.appendChild(slider);
        sidebar.appendChild(sliderContainer);
    }
}


function createButtons () {
    const footer = document.getElementById('buttons');
    for ( let i = 2; i <= 4; i++ ) {
        let button = document.createElement('button');
        button.innerText = i + 'D';
        button.classList.add('btn');
        button.onclick = function (e) {
            drawSimplex(i);
            createSliders(i);
            for ( const b of buttons ) {
                b.classList.remove('active');
            }
            e.target.classList.add('active');
            computePoint();
        }
        footer.appendChild(button);
        buttons.push(button);
    }
}


function computePoint () {
    const sliders = document.getElementById('left-controls');
    let logits = [];
    for ( const c of sliders.children ) {
        logits.push(parseFloat(c.children[1].value));
    }
    let perm = MATH.argsort(logits).reverse();
    for ( let b of Object.values(simplex.barycentricRegions) ) {
        b.material.opacity = .4;
    }
    let br = simplex.barycentricRegions[perm.join(',')];
    br.material.opacity = .6;
    if ( point !== undefined ) {
        point.parent.remove(point);
    }
    let prob = MATH.softmax(logits);
    point = simplex.plot_project( [prob] );
    scene.add(point);
    point.children[0].material.depthTest = false;
    let proj = simplex.project( [prob] )[0];
    let vp = new THREE.Vector3(...proj);
    // controls.target = vp;
    while (results.firstChild) {
        results.firstChild.remove()
    }
    let resultDiv = document.createElement('div');
    let permDiv = document.createElement('div');
    permDiv.classList.add('permdiv');
    let probDiv = document.createElement('div');
    probDiv.classList.add('probdiv');
    for ( let p of perm ) {
        let permSpan = document.createElement('div');
        permSpan.classList.add('perm');
        const color = '#' + new THREE.Color(simplex.colors[p]).getHexString();
        permSpan.style.color = color;
        permSpan.innerText = simplex.labels[p].innerText;
        permDiv.appendChild(permSpan);

        let probSpan = document.createElement('div');
        probSpan.classList.add('prob');
        probSpan.style.color = color;
        probSpan.innerText = prob[p].toFixed(2);
        probDiv.appendChild(probSpan);
    }
    resultDiv.appendChild(permDiv);
    resultDiv.appendChild(probDiv);
    results.appendChild(resultDiv);
}


const canvas = document.getElementById('canvas');
const container = document.getElementById('container');
const results = document.getElementById('results');


const renderer = new THREE.WebGLRenderer({canvas, antialias: true});
renderer.setClearColor("#fafafc");
renderer.setSize(canvas.clientWidth, canvas.clientHeight);
renderer.setPixelRatio( window.devicePixelRatio );

container.appendChild(renderer.domElement);

let	labelRenderer = new CSS2DRenderer(renderer.domElement);
labelRenderer.setSize( canvas.clientWidth, canvas.clientHeight );
labelRenderer.domElement.style.position = 'absolute';
labelRenderer.domElement.style.top = '0px';
labelRenderer.domElement.style.pointerEvents = 'none';

container.appendChild(labelRenderer.domElement);


const camera = new THREE.PerspectiveCamera( 50, window.innerWidth / window.innerHeight, .1, 2000 );
let campos;
if ( canvas.clientWidth >= 1280 ) {
    campos = [3.5, 3.5, 3];
}
else if ( canvas.clientWidth >= 768 ) {
    campos = [5, 5, 3];
}
else {
    campos = [7, 7, 6];
}
camera.position.set(...campos);
camera.lookAt(new THREE.Vector3(0, 0, 0));

const controls = new OrbitControls(camera, renderer.domElement);
// const controls = new TrackballControls(camera, renderer.domElement);

const scene = new THREE.Scene();

const ambientLight = new THREE.AmbientLight( 0xd1d1d1 );
scene.add( ambientLight );

let colors = new Colors();

let simplex, point;
let buttons = [];

createButtons();

buttons[1].click();


// let p = MATH.softmax([1., 3., 0., 1.]);
// console.log(p);
// p = s.plot_project([p]);
// scene.add(p);

// s.remove();

// let braid = braidArrangement(.9);
// scene.add(braid);

// let pm = new Permutohedron([0, 0, 0], 4, 1., .25);
// pm.add_to(scene);

animate();
